module.exports = __webpack_public_path__ + "static/media/center-bottom.c26f9040.png";